import dateUtils from "../../utils/DateUtils" 
import ValuerOverviewMessenger from "./ValuerOverviewMessenger" 
import {useNavigate} from "react-router-dom" 
import {useEffect, useState} from "react"
import check from "../../assets/check.png"
import cloud from "../../assets/upload_cloud.png"
import ImageUtils from "../../utils/ImageUtils" 
import valuer_api from "../../api/valuer.js"
import GenericDialog from "../GenericDialog"
import DropDownSelector from "./yaml_template/DropDownSelector"
import UploadYamlTemplate from "./yaml_template/UploadYamlTemplate"
import template from "../../api/template"

const ValuerReviewOverview = (props) => {
    const navigate = useNavigate()

    const summaryId = props.summaryId
    const history = props.history
    const profile = props.profile
    const updateHistory = props.updateHistory
    const requestId = props.requestId
    const getReport = props.getReport

    const firstHistoryItem = props.history?.[0]
    const reportTypeReq = firstHistoryItem?.property_type
    // 1 = Residential, 2 = HMO
    const reportTypeToTemplateId = {
        1: 1,
        2: 1
    }

    const [pdf, setPdf] = useState()
    const [base64, setBase64] = useState("")
    const [updated, setUpdated] = useState(false)
    const [reportType, setReportType] = useState(1)

    const [showUploadedDialog, setShowUploadedDialog] = useState(false)

    const [showErrorDialog, setShowErrorDialog] = useState(false)
    const [error, setError] = useState()
    const okButton = [{"text":"OK", "id": "1"}]

    const [defaultTemplateId, setDefaultTemplateId] = useState(null)
    const [templateId, setTemplateId] = useState(null)

    const [report, setReport] = useState(null)



    useEffect(() => {
        if (!report) return;
        if (defaultTemplateId != null) return;

        const orgNameRaw = report?.request?.orgname ?? "";

        // Robust match: trims + case-insensitive + handles both staging & live names
        // NOTE: This has been done to allow for testing on staging first, but still accept G. B in
        const orgName = orgNameRaw.trim().toLowerCase();
        const gatehouseOrgNames = [
            "gatehouse bank",
            "gatehouse bank - example for testing",
        ].map((s) => s.toLowerCase());

        const isGatehouseOrg = gatehouseOrgNames.includes(orgName);
        const hasIncomingReportReq = reportTypeReq != null;

        if (isGatehouseOrg && !hasIncomingReportReq) {
            setDefaultTemplateId(3);
            return;
        }

        if (hasIncomingReportReq) {
            const mappedId = reportTypeToTemplateId[reportTypeReq] ?? 1;
            setDefaultTemplateId(mappedId);
            return;
        }

        setDefaultTemplateId(1);
    }, [report, reportTypeReq, defaultTemplateId]);




    const handleDragOver = (ev) => {
        ev.preventDefault()
    }

    useEffect(() => {
        if (requestId) {
            valuer_api.getReport(requestId).then((res) => {
                const _report = res.data
                setReport(_report)
                if (_report.template_id !== null) {
                    setDefaultTemplateId(_report.template_id) // override default with stored one
                }
            })
        }
    }, [requestId])

    const handleDrop = async (ev) => {
        ev.preventDefault()
        let _files = ev.dataTransfer.files
        let _temp_pdf = []
        let _temp_base64 = ""
        if (_files[0].type === "application/pdf" && _files[0].size < 100000000) {
            setUpdated(true)
            let base64_image = await ImageUtils.convertBase64(_files[0])
            let _file = {name: _files[0].name, base64: base64_image, caption: ""}
            _temp_pdf.push(_file)
            let _temp_base64_array = base64_image.split(",")
            _temp_base64 = _temp_base64_array[1]
            setReportType(2)
        }
        if (_temp_pdf.length) setPdf(_temp_pdf[0])
        setBase64(_temp_base64)
        try {
            // Send selected template_id to backend
            await valuer_api.putReport(requestId, { template_id: templateId });
        } catch (err) {
            setError("Failed to save template selection for manual upload.");
            setShowErrorDialog(true);
        }


    }

    const handleManualUpload = () => {
        if (reportType === 1 || !base64 || !updated) return 
        let _body = {base64: base64}
        let response = valuer_api.postManualPdfUpload(summaryId, _body) 
        response.then(
            (response) => {
                setShowUploadedDialog(true)
                getReport()
            }
        ).catch((err) => {
            if (err.response.data.description) setError(err.response.data.description)
            else setError("Failed to upload report") 
            setShowErrorDialog(true) 
        })
    }

    const getManualUpload = () => {
        if (!summaryId) return 
        let response = valuer_api.getManualPdfUpload(summaryId) 
        response.then(
            (response) => {
                let _data = response.data.manual_upload
                if (_data) setReportType(2)
            }
        ).catch((err) => {
            setError("Failed to get manual upload status") 
            setShowErrorDialog(true) 
        })
    }

    const handleOKDialogResult = (res) => {
        setShowErrorDialog(false) 
        setShowUploadedDialog(false)
    }

    useEffect(() => {
        getManualUpload()
    }, [summaryId])

    return (
        <>
            <div className="valuer-overview-container">
                <div className="valuer-overview-actions-container">
                    {/* LEFT FORM SECTION */}
                    <div className="valuer-overview-form-container">
                        <div className="valuer-overview-form-title">Report type to send to client</div>
                        <div style={{ marginTop: "8px" }}>
                            <DropDownSelector
                                defaultId={defaultTemplateId}
                                onChange={(id) => setTemplateId(id)}
                            />
                        </div>

                        <div className="valuer-overview-form-options-container">
                            <div className="valuer-overview-form-option-container small">
                                <div className="valuer-overview-form-selector-container" />
                                {templateId !== null && templateId !== -1 && (
                                    <div
                                        className="valuer-overview-form-button left link"
                                        onClick={async () => {
                                            if (!requestId || !templateId) return;

                                            try {
                                                // Send selected template_id to backend
                                                await valuer_api.putReport(requestId, { template_id: templateId });

                                                // Only navigate after successful update
                                                navigate(`/valuer/amend/${templateId}/${requestId}`);
                                            } catch (err) {
                                                setError("Failed to save template selection before navigating");
                                                setShowErrorDialog(true);
                                            }
                                        }}
                                    >
                                        Go to form
                                    </div>
                                )}

                                {templateId === -1 && (
                                    <div className="valuer-overview-upload-container">
                                        <div className="valuer-dropzone small" onDragOver={handleDragOver} onDrop={handleDrop}>
                                            <img src={cloud} alt="upload cloud" />
                                            <div>{pdf ? pdf.name : "Drag and Drop files to Upload"}</div>
                                        </div>
                                        <div
                                            className={
                                                !updated || !base64 || !pdf
                                                    ? "valuer-overview-form-button disabled"
                                                    : "valuer-overview-form-button link"
                                            }
                                            onClick={handleManualUpload}
                                        >
                                            Save PDF
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* VERTICAL DIVIDER */}
                    <div className="valuer-overview-divider" />

                    {/* RIGHT INTERNAL DISCUSSION */}
                    <div className="valuer-overview-form-container small">
                        <div className="valuer-overview-form-title">Internal case discussion</div>
                        <div className="vertical-spacer" />
                        <div
                            className="valuer-overview-form-button left link"
                            onClick={() => requestId && navigate(`/valuer/chat/${summaryId}`)}
                        >
                            Discuss Case
                        </div>
                    </div>
                </div>

                <div className="valuer-overview-grid-rows">
                    {history &&
                        history.map((entry) =>
                            entry.type_id !== 1 && entry.comment ? (
                                <div className="valuer-overview-grid-row" key={entry.id || entry.entry_date}>
                                    <div className="comment col">{entry.comment}</div>
                                    <div className="date col">
                                        {dateUtils.display_date_time(entry.entry_date * 1000)}
                                    </div>
                                </div>
                            ) : null
                        )}
                </div>

                {history && profile && (
                    <ValuerOverviewMessenger
                        profileRole={profile.role_id}
                        history={history}
                        summaryId={summaryId}
                        getHistory={updateHistory}
                    />
                )}

                {showUploadedDialog && (
                    <GenericDialog
                        title="Upload Succesful"
                        text="Your PDF was successfully uploaded"
                        buttons={okButton}
                        result={handleOKDialogResult}
                    />
                )}

                {showErrorDialog && (
                    <GenericDialog
                        title="Review - Error"
                        text={error}
                        buttons={okButton}
                        buttons={okButton}
                        result={handleOKDialogResult}
                    />
                )}
            </div>
        </>
    )

}

export default ValuerReviewOverview